/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_DisclaimerInputs */

const en_projects_disclaimer = /** @type {(inputs: Projects_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These concepts explore possible customer experiences. Their names, property details and example data are illustrative.`)
};

const lv_projects_disclaimer = /** @type {(inputs: Projects_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šie koncepti pēta iespējamu klienta pieredzi. To nosaukumi, īpašumu apraksti un piemēru dati ir ilustratīvi.`)
};

/**
* | output |
* | --- |
* | "These concepts explore possible customer experiences. Their names, property details and example data are illustrative." |
*
* @param {Projects_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_disclaimer = /** @type {((inputs?: Projects_DisclaimerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_DisclaimerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_disclaimer(inputs)
	return en_projects_disclaimer(inputs)
});